import React from "react";

export default function TermsConditions() {
  return (
    <div className="terms-conditions">
      <div className="contentOfTermsCondition">
        <h1>Terms and Conditions</h1>

        <p>
          Welcome to BTC Japan, the online auction car trading and bidding
          website. By using our website, you agree to comply with and be bound
          by the following Terms and Conditions, which together with our Privacy
          Policy govern BTC Japan's relationship with you.
        </p>

        <h2>Acceptance of Terms</h2>
        <p>
          By using our website, you agree to comply with and be bound by these
          Terms and Conditions. If you disagree with any part of these terms,
          please do not use our website.
        </p>

        <h2> Use of Our Services</h2>
        <p>
          You agree to use our services for lawful purposes only. You may not
          use our services to:
        </p>
        <ul>
          <li>Engage in any illegal activities.</li>
          <li>
            Violate any local, state, national, or international law or
            regulation.
          </li>
          <li>
            Interfere with or disrupt the services or servers connected to the
            services.
          </li>
          <li>Impersonate any other person or entity.</li>
        </ul>

        <h2> User Accounts</h2>
        <p>
          To access certain features of our website, you may be required to
          register for an account. You are responsible for maintaining the
          confidentiality of your account and password and for restricting
          access to your computer. You agree to accept responsibility for all
          activities that occur under your account.
        </p>
        <h2> User Conduct</h2>
        <p>When using our website, you agree not to:</p>
        <ul>
          <li>
            Engage in any activity that disrupts or interferes with the proper
            functioning of the website.
          </li>
          <li>
            Attempt to gain unauthorized access to any part of the website or
            any other systems or networks connected to the website.
          </li>
          <li>
            Use the website for any fraudulent, harmful, or unlawful activities.
          </li>
          <li>
            Upload or transmit any content that contains viruses, malware, or
            other harmful code that could damage the website or other users'
            devices.
          </li>
        </ul>
        <h2> Intellectual Property</h2>
        <p>
          All content on our website, including but not limited to text,
          graphics, logos, images, and software, is the property of BTC Japan
          and is protected by copyright and other intellectual property laws.
          You may not reproduce, distribute, display, or create derivative works
          from any content on our website without our express written
          permission.
        </p>

        <h2> Disclaimer</h2>
        <p>
          The information provided on our website is for general informational
          purposes only. We make no representations or warranties of any kind,
          express or implied, about the completeness, accuracy, reliability,
          suitability, or availability of the information on the website for any
          purpose.
        </p>

        <h2> Entire Agreement</h2>
        <p>
          These Terms and Conditions constitute the entire agreement between you
          and BTC Japan regarding the use of our website, superseding any prior
          agreements or understandings between you and us.
        </p>
        <h2> Limitation of Liability</h2>
        <p>
          In no event shall BTC Japan be liable for any indirect, consequential,
          or incidental damages, including, but not limited to, loss of profits,
          data, or other intangible losses, arising out of or in connection with
          your use of the website.
        </p>

        <h2> Indemnification</h2>
        <p>
          You agree to indemnify and hold BTC Japan, its affiliates, and their
          respective officers, directors, agents, and employees harmless from
          and against any and all claims, losses, expenses, demands, or
          liabilities, including legal fees and costs, arising out of or in
          connection with your use of the website or your violation of these
          Terms and Conditions.
        </p>

        <h2> Contact Us</h2>
        <p>
          If you have any questions or concerns regarding our Terms and
          Conditions, please contact us.
        </p>
      </div>
    </div>
  );
}
